// Which build this tab is actually running, and which one the server has now.
// A tab left open all day keeps running the bundle it loaded, so cache headers
// alone cannot tell someone their app is a release behind.

const MAIN_BUNDLE = /\/static\/js\/main\.[^/]+\.js$/;

export function runningBundle(doc = document) {
  const script = Array.from(doc.querySelectorAll('script[src]'))
    .map((tag) => tag.getAttribute('src'))
    .find((src) => MAIN_BUNDLE.test(src || ''));
  // The dev server serves an unhashed bundle, so there is no release to compare.
  return script || null;
}

export function bundleFromManifest(manifest) {
  const file = manifest?.files?.['main.js'];
  return MAIN_BUNDLE.test(file || '') ? file : null;
}

export async function fetchLatestBundle(fetchImpl = fetch) {
  const response = await fetchImpl('/asset-manifest.json', { cache: 'no-store' });
  if (!response.ok) return null;
  return bundleFromManifest(await response.json());
}
